export default function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20aerial%20view%20of%20a%20massive%20modern%20airport%20terminal%20under%20construction%20at%20golden%20hour%20with%20visible%20steel%20framework%20and%20construction%20cranes%2C%20cinematic%20lighting%20with%20warm%20orange%20and%20blue%20tones%2C%20professional%20architectural%20photography%20showing%20scale%20and%20complexity%20of%20mega%20infrastructure%20project%2C%20high%20detail%20construction%20site%20with%20BIM%20coordination%20elements&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
          alt="Major Infrastructure Project"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="max-w-3xl">
          <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Trusted Estimating Tracking and BIM Solutions for Heavy Civil Projects
          </h1>
          <p className="text-xl lg:text-2xl text-white/90 mb-8 leading-relaxed">
            Large-scale construction consulting specializing in Estimating, BIM Modeling, and P6/MS Project Scheduling
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollToSection('services')}
              className="bg-orange-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-orange-700 transition-all duration-300 hover:scale-105 whitespace-nowrap"
            >
              Explore Our Services
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white hover:text-gray-900 transition-all duration-300 whitespace-nowrap"
            >
              View Portfolio
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}